module.exports = __webpack_public_path__ + "img/eHealth_logo_1.cf822109.png";